module.exports = __webpack_public_path__ + "static/1276385699.07c67b58.jpg";